<div class="container px-0">
    <div class="my-5 pt-4 w-100 row px-0">
        <div class="back-btn col-sm-12 mb-3 mt-3 col-md-12 col-lg-3 px-0 d-flex justify-content-sm-center justify-content-md-center justify-content-lg-start">
            <img width="32" height="32" *ngIf="!isUserLoggedIn" routerLink="/login" class="cursor-pointer" src="assets/icons/arrow-left.svg" alt="">
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 px-0 text-center d-flex justify-content-center">
            <h1 class="text-32-600-125 text-c6">{{"Discover what's going on the other side of the globe" | translate}}</h1>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-3 d-none d-sm-flex px-0 d-flex justify-content-sm-center justify-content-md-center justify-content-lg-end">
            <button *ngIf="userDataRole != 2" [routerLink]="['/map-view']" [queryParams]="{ agm: 'v'}" class="map-view-btn text-16-500-125 text-c3 d-flex align-items-center gap-3">
                <img src="assets/icons/treasure-map.svg" alt="">
                {{'Go to map view' | translate}}</button>
        </div>
    </div>
    <!-- filters -->
    <div class="w-100 d-flex align-items-center justify-content-center">
        <div class="w-46">
            <div class="input-container">
                <img src="assets/icons/search.svg" alt="">
                <input class="px-4 search-input text-14-400-157" type="text" placeholder="{{'Search category or country' | translate}}" [(ngModel)]="searchTerm" (ngModelChange)="search()" (keydown)="restrictSpace($event)">
            </div>
            <div class="d-flex gap-3 mt-4">
                <!-- Category filter -->
                <app-select-input
                class="w-100"
                [showLabel]="true"
                [label]="'Category'"
                [optionList]="CategoryOptionList"
                [selectedId]=""
                (onItemChange)="subjectChange($event)">
                </app-select-input>
                <!-- Countries filter -->
                <app-select-input
                class="w-100"
                [showLabel]="true"
                [label]="'Country'"
                [optionList]="lstCountries"
                [selectedId]=""
                (onItemChange)="countryChange($event)">
                </app-select-input>
            </div>
        </div>
    </div>
    <!-- VIDEOS list view -->
    <div class="mt-5 vide-list-view">
        <!-- for sm and larger screen sizes -->
        <div class="d-none mt-1 d-sm-flex flex-wrap gap-4 video-list">
            <div *ngFor="let movies of AllMovies;let i=index;" class="video-item-container">
                <div (click)="movieClick(movies)" class="w-100 position-relative video-thumb-container">
                    <img src="assets/images/play-icon.svg" alt="" class="video-thumb-icon cursor-pointer">
                    <img [src]="movies?.movieThumbnail" alt="" class="img-fluid pointer-cursor thumbnail">
                </div>
                <div class="d-flex align-items-center py-2">
                    <span class="me-2 d-flex align-items-center">
                        <img height="18" [src]="movies.country.flag" alt="">
                    </span>
                    <span class="text-12-400-183 text-c6">{{movies.country.name}}</span>
                </div>
                <p class="text-14-500-142 text-c4">
                    {{movies.description}}
                </p>
            </div>
            <div *ngIf="AllMovies?.length === 0 && !loader" class="w-100 d-flex justify-content-center flex-column align-items-center">
            <p class="text-14-400-157">
                {{"No videos available for selected criteria, Kindly try changing parameters" | translate}}</p>
            </div>
            <div class="w-100 d-flex justify-content-center text-center loader-div" *ngIf="loader">
                <img src="assets/images/loader.gif" alt="" class="load">
            </div>
        </div>
        <!-- for below 576px -->
        <div class="d-block d-sm-none mt-1 gap-4 video-list-mb">
            <div *ngFor="let movies of AllMovies;let i=index;" class="video-item-container-mb mb-4">
                <div (click)="movieClick(movies)" class="w-100 position-relative video-thumb-container-mb">
                    <img  width="50"  src="assets/images/play-icon.svg" alt="" class="video-thumb-icon cursor-pointer">
                    <img [src]="movies?.movieThumbnail" alt="" class="img-fluid pointer-cursor thumbnail-mb">
                </div>
                <div>
                    <p class="text-14-500-142 text-c4 mb-0">
                        {{movies.description}}
                    </p>
                    <div class="d-flex align-items-center py-2">
                        <span class="me-2 d-flex align-items-center">
                            <img height="18" [src]="movies.country.flag" alt="">
                        </span>
                        <span class="text-12-400-183 text-c6">{{movies.country.name}}</span>
                    </div>
                </div>
            </div>
            <div *ngIf="AllMovies?.length === 0 && !loader" class="w-100 d-flex justify-content-center flex-column align-items-center">
                <p class="text-14-400-157 text-center">
                {{"No videos available for selected criteria, Kindly try changing parameters" | translate}}</p>
            </div>
            <div class="w-100 d-flex justify-content-center text-center loader-div" *ngIf="loader">
                <img src="assets/images/loader.gif" alt="" class="load">
            </div>
        </div>
    </div>
</div>
